import React from "react";
import styles from "./styles.scss";

const VIDEO_ID_PATTERN = /^[\w-]{11}$/;

// Extracts the video ID from youtube.com/watch?v=, youtu.be/, /embed/ and /shorts/ URLs
export function getYouTubeVideoId(url?: string | null): string | null {
  if (!url) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^(www\.|m\.)/, "");
  let id: string | null = null;
  if (host === "youtu.be") {
    id = parsed.pathname.split("/")[1];
  } else if (host === "youtube.com" || host === "youtube-nocookie.com") {
    const [, first, second] = parsed.pathname.split("/");
    id = first === "watch" ? parsed.searchParams.get("v") : ["embed", "shorts"].includes(first) ? second : null;
  }

  return id && VIDEO_ID_PATTERN.test(id) ? id : null;
}

type YouTubeEmbedProps = {
  videoId: string;
  title?: string;
  playlistId?: string;
};

export default function YouTubeEmbed({ videoId, title, playlistId }: YouTubeEmbedProps) {
  const playlistParams = playlistId ? `?listType=playlist&list=${encodeURIComponent(playlistId)}` : "";

  return (
    <div className="youtube-embed">
      <div className="player-wrapper">
        <iframe
          className="player"
          title={title}
          src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}${playlistParams}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
